export default defineNuxtPlugin(() => {
  if (process.server) return;

  window.addEventListener('keydown', (event) => {
    const target = event.target as HTMLElement;

    // Handle Enter and Space for non-native focusable elements
    if (event.key === 'Enter' || event.key === ' ') {
      const isNativeClickable = 
        target.tagName === 'BUTTON' || 
        target.tagName === 'A' || 
        target.tagName === 'INPUT' || 
        target.tagName === 'SELECT' || 
        target.tagName === 'TEXTAREA';

      const isCustomClickable = 
        target.hasAttribute('tabindex') || 
        target.getAttribute('role') === 'button';

      if (!isNativeClickable && isCustomClickable) {
        // Prevent default behavior (like scrolling with Space)
        event.preventDefault();
        target.click();
      }
    }

    // Handle Escape for closing popups/modals
    if (event.key === 'Escape') {
      // Dispatch a global 'close-overlays' event that components can listen to
      window.dispatchEvent(new CustomEvent('close-all-overlays'));
      
      // Also try to find and click common close buttons as a fallback
      const closeButtons = document.querySelectorAll('.close-btn, .dialog-close, .v-overlay__scrim');
      if (closeButtons.length > 0) {
        // We only want to close the topmost/most relevant one if possible
        // But for now, global event is cleaner
      }
    }
  });
});
